import { common } from "./common";
import { candidate } from "./candidate";
import { crew } from "./crew";
import { enums } from "./enums";
import { error } from "./error";
import { home } from "./home";
import { plan } from "./plan";
import { user } from "./user";
import { member } from "./member";
import { category } from "./category";
import { translate } from "./translate";
import { qualification } from "./qualification";
import { skill } from "./skill";
import { position } from "./position";
import { service } from "./service";
import { term } from "./term";

export const language = {
    translations: {
        common,
        candidate,
        crew,
        enums,
        error,
        home,
        plan,
        user,
        member,
        category,
        translate,
        qualification,
        skill,
        position,
        service,
        term,
    },
};